import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import BarcodeReader from "react-barcode-reader";
import { useDebouncedCallback } from "use-debounce";
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Topbar from "../../../shared/components/topbar/Topbar";
import AddInventoryItem from "./AddInventory/AddInventoryItem";
import Button from "../../../shared/components/Buttons/Button";
import ImportInventory from "./ImportInventory/ImportInventory";
import ShrinkItemModal from "./ShrinkItemModal/ShrinkItemModal";
import {
  PRINT_LABEL_DESIGN_ENUMS,
  PRODUCT_TYPES_ENUMS,
} from "../../../system/globalEnums";
import PrintLabelModal from "./printingLabelModal/PrintLabelModal";
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal";
import AddBatchInventory from "./AddBatchInventory/AddBatchInventory";
import SearchField from "../../../shared/components/searchField/SearchField";
import FilterDropdowns from "../../../shared/components/FilterDropdowns/FilterDropdowns";
import InventoryOverviewCard from "../../../shared/components/inventoryOverviewCard/InventoryOverviewCard";
import { inventoryActions, systemActions } from "../../../redux/actions";
import {
  AddIcon,
  TickIcon,
  EditIcon,
  PrintIcon,
  CrossIcon,
  SearchIcon,
  DeleteIcon,
  BlueBoxIcon,
  ImportCSVIcon,
  ExportCSVIcon,
  ActionDotsIcons,
  ShareIcon,
} from "../../../assets/icons/iconsProvider";
import {
  toastType,
  globalConstants,
  defaultGridState,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
  EMPTY_STRING,
  TABLE_IDS,
  INSTOCK_FILTER_OPTIONS,
  skeletonArray,
  TABLE_COLUMNS,
  toastMessages,
  SPINNER_MESSAGES,
} from "../../../constants";
import {
  downloadCSV,
  customToast,
  exportTagFunc,
  handleKeyDown,
  LoadingIndicator,
  getDefaultFilterType,
  exportStringArrayFunc,
  isButtonDisable,
  isSpinnerEnabled,
  prepareFilterForPaginationCall,
  parseToThousandSeperatorWholeNumber,
  createCompanyDynamicUrl,
  beautifyStringForImport,
  getDefaultFilterCategory,
  exportUpcFunc,
  getRowId,
  isEmployeeLogin,
  getAddInventoryPricePayloadObject,
  getAddInventoryRootPayloadPartialObject,
  isTransferInventoryEnabled,
  getStoreLogo,
  formatCurrency,
  getSkuColumnWithImage,
  getActionColumnOfAgGridReact,
  getProductNameColumn,
  getProductConditionColumn,
  getProductTypeColumn,
  getProductCategoryColumn,
  getProductTagColumn,
} from "../../../shared/utility";
import {
  printZebraData,
  getDpi,
} from "../../../shared/Printers/ReceiptPrinters/printReceipt";
import { inventoryService } from "../../../services";
import ClickableTooltip from "../../../shared/components/toolTipComponent/ClickableTooltip";
import ServerPaginationTable from "../../../shared/components/agGrid/ServerPaginationTable";
import SummaryCardSkeleton from "../../../shared/Skeletons/inventorySkeletons/SummaryCardSkeleton";
import DropdownSkeleton from "../../../shared/Skeletons/DropdownSkeleton/DropdownSkeleton";
import SearchCompanyInventory from "./SearchCompanyInventory/SearchCompanyInventory";
import TransferInventoryModal from "./TransferInventoryModal/TransferInventoryModal";

//-------Inventory Items component start here
const Items = (props) => {
  const {
    user,
    stores,
    company,
    inventory,
    currentStore,
    spinnerArray,
    addCustomItem,
    isAddModalOpen,
    toggleAddModal,
    quantityShrink,
    deleteInventory,
    updateInventory,
    activateSpinner,
    itemOrganization,
    emptyAllInventory,
    deactivateSpinner,
    currentStoreCompany,
    defaultZebraPrinter,
    getInventorySummary,
    importCsvFileInventory,
    getPaginatedInventory,
    isBatchInventoryModal,
    setIsBatchInventoryModal,
    isDraftConfirmationModal,
    activateImportInventorySpinner,
    draggableNotification,
  } = props;

  //-------Reducer
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  //-------Inventory Reducer
  const { allInventory, inventorySummary } = inventory;

  //------navigate links
  const navigate = useNavigate();
  const { state } = useLocation();
  const gridRef = useRef();
  const rowBeingEditRef = useRef({});
  const rowBeingEditParamRef = useRef({});
  const tooltipRef = useRef();

  const scrollRef = useRef(state?.scrollRef ?? 0);
  const [isInlineEditRefresh, setIsInlineEditRefresh] = useState(false);
  const [isEditingInline, setIsEditingInline] = useState(false);
  const [inlineEditRefreshScrollValue, setInlineEditRefreshScrollValue] =
    useState(0);

  //-------usestate
  const [gridState, setGridState] = useState(
    state?.gridState || defaultGridState
  );
  const [searchText, setSearchText] = useState(
    gridState?.searchQuery || EMPTY_STRING
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowsToDeleted, setRowsToDeleted] = useState([]);
  const [singlePrintArray, setSinglePrintArray] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [ClearSelectedRows, setclearSelectedRows] = useState(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [itemEditShrinkModal, setItemEditShrinkModal] = useState(false);
  const [importInventoryModal, setImportInventoryModal] = useState(false);
  const [addInventoryItemModal, setAddInventoryItemModal] = useState(false);
  const [itemDeleteShrinkModal, setItemDeleteShrinkModal] = useState(false);
  const [debouncedSearchText, setDebouncedSearchText] = useState(
    gridState?.searchQuery || EMPTY_STRING
  );
  const [isTransferInventoryModal, setIsTransferInventoryModal] =
    useState(false);
  const [searchProductType, setSearchProductType] = useState(
    getDefaultFilterType(
      customTypes,
      gridState?.productType || PRODUCT_TYPES_ENUMS.ALL
    )
  );
  const [isSearchCompanyInventoryModal, setIsSearchCompanyInventoryModal] =
    useState(false);
  const [searchProductCategory, setSearchProductCategory] = useState(
    getDefaultFilterCategory(customCategories, gridState?.productCategory)
  );
  const [searchProductSubCategory, setSearchProductSubCategory] = useState(
    getDefaultFilterCategory(customSubCategories, gridState?.productSubCategory)
  );
  const [searchInStockFilter, setSearchInStockFilter] = useState(
    gridState?.inStockFilter || INSTOCK_FILTER_OPTIONS.ALL
  );
  const storeInventorySummary = inventorySummary;
  const disableImportInventoryButton =
    (draggableNotification?.message === SPINNER_MESSAGES.INVENTORY_IMPORT &&
      draggableNotification?.isVisible) ||
    currentStore?.persistentDraggableNotification?.includes(
      SPINNER_MESSAGES.INVENTORY_IMPORT
    ); // Disable import inventory button if inventory is already importing.

  const toggleItemDeleteShrinkModal = () => {
    setItemDeleteShrinkModal(!itemDeleteShrinkModal);
  };

  const toggleIsSearchCompanyInventoryModal = () => {
    setIsSearchCompanyInventoryModal(!isSearchCompanyInventoryModal);
  };

  const toggleItemEditShrinkModal = () => {
    setItemEditShrinkModal(!itemEditShrinkModal);
  };

  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const toggleTransferInventoryModal = () => {
    setIsTransferInventoryModal((prev) => !prev);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  const handleConfirmYesButtonClick = () => {
    toggleConfirmationModal();
    toggleItemDeleteShrinkModal();
  };

  const handleDeleteNoButtonClick = () => {
    handleDeleteInventory(false);
    toggleItemDeleteShrinkModal();
  };
  const handleDeleteYesButtonClick = () => {
    handleDeleteInventory(true);

    const dataToShrink = rowsToDeleted?.filter((item) => {
      if (item?.price?.quantity > 0 || item?.price?.quantity < 0) {
        return {
          ...item,
          shrinkQuantity: item.price.quantity,
        };
      }
      return false;
    });
    if (dataToShrink?.length) {
      quantityShrink(dataToShrink);
    }

    setRowsToDeleted([]);
    toggleItemDeleteShrinkModal();
  };

  const handleEditNoButtonClick = () => {
    toggleItemEditShrinkModal();
    handleUpdateInventory(false);
  };
  const handleEditYesButtonClick = () => {
    toggleItemEditShrinkModal();
    handleUpdateInventory(true);
  };

  const handleDeleteInventory = (isAddShrinkTracking) => {
    const deleteItemsIds = rowsToDeleted.map((item) => item.id);
    deleteInventory(
      deleteItemsIds,
      currentStore?.id,
      gridState,
      isAddShrinkTracking
    );
    setSelectedRows([]);
    setclearSelectedRows(true);
  };

  //-------Handle Add button click
  const handleExport = async (allData) => {
    activateImportInventorySpinner({
      isVisible: true,
      message: "Exporting Inventory...",
    });
    await inventoryService.getAllInventory(currentStore?.id).then(
      (response) => {
        downloadCSV(
          filterColumnforExport(response),
          inventoryConstants.EXPORT_FILE_NAME
        );
        activateImportInventorySpinner({ isVisible: false, message: "" });
      },
      (error) => {
        customToast(error, toastType.ERROR);
        activateImportInventorySpinner({ isVisible: false, message: "" });
      }
    );
  };
  const handleAddIventoryItemClick = () => {
    toggleAddModal(true);
    toggleAddInventoryItemModal();
    scrollRef.current = 0;
    gridRef.current.api.gridBodyCtrl.eBodyViewport.scrollTop = 0;
  };

  //-------Toggle Add Inventoty Item Modal
  const toggleAddInventoryItemModal = () =>
    setAddInventoryItemModal(!addInventoryItemModal);

  //-------Toggle Print Label Modal
  const togglePrintLabelModal = () => {
    setPrintLabelModal(!printLabelModal);
  };

  const handleClearFilter = () => {
    updateGridState(defaultGridState);
    setSearchText("");
    setDebouncedSearchText("");
  };

  //------Toggle Import Inventory Modal
  const toggleImportInventoryModal = () => {
    importInventoryModal && handleClearFilter();
    setImportInventoryModal(!importInventoryModal);
  };

  const handlePrintLabelButtonClick = (props) => {
    setSelectedRows([]);
    setclearSelectedRows(true);
    setSinglePrintArray([props.data]);
    togglePrintLabelModal();
    // if (props.hideTooltipCallback) {
    //   props.hideTooltipCallback();
    // }
  };

  //-------handle Edit Submit Click
  const handleEditSubmitClick = (params) => {
    const { price, originalQuantity } = rowBeingEditRef.current;
    if (price.quantity < originalQuantity) {
      toggleItemEditShrinkModal();
      return;
    }
    handleUpdateInventory(false);
  };

  //-------handle update inventory
  const handleUpdateInventory = (isStolen) => {
    const {
      id,
      margin,
      price,
      originalQuantity,
      imgUrl,
      store,
      product_name,
      category_name,
      subcategory,
      trackQuantity,
    } = rowBeingEditRef.current;
    if (id) {
      const updateInventoryObject = {
        ...getAddInventoryRootPayloadPartialObject(
          rowBeingEditRef.current,
          true
        ),
        id: id,
        margin: margin || 0,
        imgUrl: imgUrl,
        product_name: product_name,
        category_name: category_name,
        subcategory: subcategory,
        trackQuantity: trackQuantity || true,
        price: getAddInventoryPricePayloadObject(
          {
            ...price,
            costOfGoods: price.unit_purchase_price,
            inStockPrice: price.unit_sell_price,
          },
          true
        ),
      };

      if (isStolen) {
        const ShrinkRowData = {
          ...rowBeingEditRef.current,
          price: {
            ...rowBeingEditRef.current.price,
            quantity: originalQuantity,
          },
          shrinkQuantity: originalQuantity - price.quantity,
        };
        delete ShrinkRowData["originalQuantity"];
        quantityShrink([ShrinkRowData]);
      }
      setIsEditingInline(true);
      setInlineEditRefreshScrollValue(scrollRef.current);
      updateInventory(
        store?.id,
        updateInventoryObject,
        true,
        gridState,
        false,
        0,
        isStolen
      );
      rowBeingEditRef.current = {};
    }
  };

  const handlePrintLabelClick = () => {
    setSinglePrintArray([]);
    togglePrintLabelModal();
  };

  //-------Handle Delete button click
  const handleDeleteClick = (props) => {
    setRowsToDeleted([props.data]);
    toggleConfirmationModal();
    // if (props.hideTooltipCallback) {
    //   props.hideTooltipCallback();
    // }
  };

  //-------Handle Edit button click
  const handleEditClick = (row) => {
    navigate(createCompanyDynamicUrl(routesPathConstants.INVENTORY_EDIT), {
      state: {
        data: row,
        isEdit: true,
        currentStore: currentStore,
        gridState: gridState,
        scrollRef: scrollRef.current ?? 0,
      },
    });
  };

  //-------Handle Single Item Transfer Click
  const handleTransferClick = (params) => {
    setSelectedRows([]);
    setclearSelectedRows(true);
    setSinglePrintArray([params.data]);
    toggleTransferInventoryModal();
  };

  const updateGridState = (gridState) => {
    getPaginatedInventory(currentStore?.id, gridState);
    setGridState(gridState);
  };

  const defaultColDef = useMemo(() => {
    if (isEditingInline) {
      setIsEditingInline(false);
      setIsInlineEditRefresh(true);
    }
    return {
      cellStyle: { display: "flex", alignItems: "center" },
      headerComponentParams: {
        gridState: gridState,
        updateGridState: updateGridState,
      },
    };
    // eslint-disable-next-line
  }, [gridState]);

  const handleRefreshCells = (params) => {
    params.api.refreshCells({
      columns: [
        "id",
        "price.unit_sell_price",
        "price.unit_purchase_price",
        "price.quantity",
      ],
      rowNodes: [params.node],
      force: true,
    });
  };

  const handleCancelEdit = (params) => {
    rowBeingEditRef.current = {};
    rowBeingEditParamRef.current = {};
    params.api.clearFocusedCell();
    redrawTopRows(params);
    handleRefreshCells(params);
  };

  const handleStandardLabelPrint = async (params) => {
    if (!defaultZebraPrinter) {
      customToast(toastMessages.NO_PRINTER_DEVICE_FOUND, toastType.ERROR);
      return;
    }
    activateSpinner(inventoryConstants.LABELS_PRINTING);
    customToast("Labels Printing", toastType.SUCCESS);
    const storeLogo = currentStore?.showOnLabels
      ? await getStoreLogo(currentStore, await getDpi(defaultZebraPrinter))
      : false;
    const labelToPrint = {
      sku: params.data.sku,
      title: params.data.product_name,
      stockQuantity: params.data.price.quantity,
      printQuantity: 1,
      price: {
        type: params.data.price.type,
        grade: params.data.price.grade,
        unit_sell_price: params.data.price.unit_sell_price,
      },
      category_name: params.data.category_name,
      product_name: params.data.product_name,
      productType: params.data.productType,
      tags: params.data.tags,
    };

    printZebraData(
      [labelToPrint],
      PRINT_LABEL_DESIGN_ENUMS.STANDARD.value,
      storeLogo,
      defaultZebraPrinter,
      deactivateSpinner
    );
  };

  function actionCellRenderer(params) {
    if (params.data?.id) {
      if (rowBeingEditRef.current.id === params.data.id) {
        return (
          <>
            <button
              id={`modalTool${params.data.id}`}
              className="action-Button-Wrapper"
              onClick={() => handleEditSubmitClick(params)}
            >
              <TickIcon className="cursor-pointer text-primary" />
            </button>
            <button
              id={`modalTool${params.data.id}`}
              className="action-Button-Wrapper"
              onClick={() => handleCancelEdit(params)}
            >
              <CrossIcon className="cursor-pointer" />
            </button>
          </>
        );
      } else {
        const isDisabled = isSpinnerEnabled(
          spinnerArray,
          inventoryConstants.LABELS_PRINTING
        );
        return (
          <div
            onMouseLeave={() => {
              tooltipRef.current?.close();
            }}
          >
            <button
              type="button"
              onClick={() => handleStandardLabelPrint(params)}
              className={`action-Button-Wrapper ${
                isDisabled && "disabled-transaprent-button"
              }`}
              disabled={isDisabled}
            >
              <PrintIcon className="cursor-pointer" />
            </button>

            <>
              <ClickableTooltip
                anchorSelect={`#tool${params.data.id}`}
                openOnClick={true}
                tooltipRef={tooltipRef}
              >
                <Button
                  className="w-100"
                  IconImage={EditIcon}
                  label={buttonNameConstants.EDIT}
                  handleClick={() => handleEditClick(params.data)}
                  buttonType={buttonTypeConstants.ACTION_BUTTON}
                />
                {isTransferInventoryEnabled(currentStoreCompany, stores) && (
                  <Button
                    className="w-100"
                    IconImage={ShareIcon}
                    label={buttonNameConstants.TRANSFER}
                    handleClick={() => handleTransferClick(params)}
                    buttonType={buttonTypeConstants.ACTION_BUTTON}
                  />
                )}
                <Button
                  className="w-100"
                  IconImage={DeleteIcon}
                  label={buttonNameConstants.DELETE}
                  handleClick={() => handleDeleteClick(params)}
                  buttonType={buttonTypeConstants.ACTION_BUTTON}
                />
                <Button
                  label={buttonNameConstants.PRINT_LABEL}
                  className="w-100"
                  buttonType={buttonTypeConstants.ACTION_BUTTON}
                  IconImage={PrintIcon}
                  handleClick={() => handlePrintLabelButtonClick(params)}
                />
              </ClickableTooltip>
              <button
                id={`tool${params.data.id}`}
                className="action-Button-Wrapper"
                onClick={() => {
                  params.api.clearFocusedCell();
                  tooltipRef.current?.isOpen
                    ? tooltipRef.current?.close()
                    : tooltipRef.current?.open({
                        anchorSelect: `tool${params.data.id}`,
                      });
                }}
              >
                <ActionDotsIcons className="cursor-pointer" />
              </button>
            </>
          </div>
        );
      }
    } else {
      return <DropdownSkeleton width="5em" height="1.5em" />;
    }
  }

  const redrawTopRows = useCallback((params) => {
    params.api.redrawRows({ rowNodes: [params.node] });
  }, []);

  // Column Definitions: Defines the columns to be displayed.
  const colDefs = useMemo(
    () => [
      getSkuColumnWithImage(),
      getProductNameColumn(handleEditClick),
      getProductTypeColumn(),
      getProductCategoryColumn(),
      getProductConditionColumn(),
      getProductTagColumn(),
      {
        headerTooltip: "Unit Purchase Price",
        headerName: "Unit Purchase Price",
        field: "price.unit_purchase_price",
        suppressKeyboardEvent: (params) => {
          const e = params.event;
          // Only suppress arrow key handling when editing inside an input
          if (
            e.target.tagName === "INPUT" &&
            ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
          ) {
            return true; // stop grid from handling arrow keys
          }

          return false;
        },
        cellRenderer: (params) => {
          return params.data?.price ? (
            params.data.id === rowBeingEditRef.current?.id ? (
              <input
                min={0}
                type="number"
                defaultValue={params.data.price.unit_purchase_price}
                className="input-textfield input-textfield-without-icon  editable-table-row-fields inventory-editable-row-fields"
                onChange={(e) => {
                  rowBeingEditRef.current = {
                    ...rowBeingEditRef.current,
                    price: {
                      ...rowBeingEditRef.current.price,
                      unit_purchase_price: e.target.value,
                    },
                  };
                }}
              ></input>
            ) : (
              <span className="inventory-cell-max-size">
                {formatCurrency(params.data.price.unit_purchase_price)}
              </span>
            )
          ) : (
            <DropdownSkeleton width="5em" height="1.5em" />
          );
        },
      },
      {
        headerTooltip: "Unit Sell Price",
        headerName: "Unit Sell Price",
        field: "price.unit_sell_price",
        suppressKeyboardEvent: (params) => {
          const e = params.event;
          // Only suppress arrow key handling when editing inside an input
          if (
            e.target.tagName === "INPUT" &&
            ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
          ) {
            return true; // stop grid from handling arrow keys
          }

          return false;
        },
        cellRenderer: (params) => {
          return params.data?.price ? (
            params.data.id === rowBeingEditRef?.current?.id ? (
              <input
                min={0}
                type="number"
                defaultValue={params.data.price.unit_sell_price}
                className="input-textfield input-textfield-without-icon  editable-table-row-fields inventory-editable-row-fields"
                onChange={(e) => {
                  rowBeingEditRef.current = {
                    ...rowBeingEditRef.current,
                    price: {
                      ...rowBeingEditRef.current.price,
                      unit_sell_price: e.target.value,
                    },
                  };
                }}
              ></input>
            ) : (
              <span className="inventory-cell-max-size">
                {formatCurrency(params.data.price.unit_sell_price)}
              </span>
            )
          ) : (
            <DropdownSkeleton width="5em" height="1.5em" />
          );
        },
      },
      {
        headerName: "Quantity",
        field: "price.quantity",
        cellRenderer: (params) => {
          return params.data?.price ? (
            params.data.id === rowBeingEditRef?.current.id ? (
              <input
                type="number"
                min={-9999}
                onKeyDown={handleKeyDown}
                defaultValue={
                  params.data.trackQuantity === undefined ||
                  params.data.trackQuantity === null ||
                  params.data.trackQuantity
                    ? params.data.price.quantity
                    : ""
                }
                className="input-textfield input-textfield-without-icon  editable-table-row-fields inventory-editable-row-fields"
                onChange={(e) => {
                  rowBeingEditRef.current = {
                    ...rowBeingEditRef.current,
                    price: {
                      ...rowBeingEditRef.current.price,
                      quantity: e.target.value,
                    },
                  };
                }}
                disabled={
                  params?.data?.serialNumber ||
                  !(
                    params.data.trackQuantity === undefined ||
                    params.data.trackQuantity === null ||
                    params.data.trackQuantity
                  )
                }
              ></input>
            ) : (
              <span className="inventory-cell-max-size">
                {params.data.trackQuantity === undefined ||
                params.data.trackQuantity === null ||
                params.data.trackQuantity
                  ? parseToThousandSeperatorWholeNumber(
                      params.data.price.quantity
                    )
                  : ""}
              </span>
            )
          ) : (
            <DropdownSkeleton width="5em" height="1.5em" />
          );
        },
      },
      getActionColumnOfAgGridReact(actionCellRenderer),
    ],
    // eslint-disable-next-line
    [defaultZebraPrinter, gridState, spinnerArray]
  );

  const getRowStyle = (params) => {
    return null;
  };

  const handleDeleteAllClick = () => {
    setRowsToDeleted(selectedRows);
    toggleConfirmationModal();
  };

  useEffect(() => {
    if (currentStore?.id) {
      if (!isEmployeeLogin(user)) {
        getInventorySummary(currentStore.id);
      }
    }
    // eslint-disable-next-line
  }, [currentStore]);

  useEffect(() => {
    return () => {
      emptyAllInventory();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (defaultZebraPrinter) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [defaultZebraPrinter]);

  const filterColumnforExport = (allData) => {
    return allData.map((row) => {
      const exportObject = {
        "Product Name": beautifyStringForImport(row.product_name),
        "Product Type": row.productType,
        "Image URL": exportStringArrayFunc([
          row.imgUrl,
          ...(row?.imgUrlExtras || []),
        ]),
        Category: row.category_name,
        Subcategory: row.subcategory,
        Condition: row.price.type,
        "Serial Number": row.serialNumber,
        Quantity: Number(row.price.quantity),
        "Cost of Goods": row.price.unit_purchase_price,
        "Sell Price": row.price.unit_sell_price,
        SKU: exportStringArrayFunc(row.sku),
        UPC: exportUpcFunc(row.upc),
        Tags: exportTagFunc(row.tags),
      };
      return exportObject;
    });
  };

  useEffect(() => {
    if (ClearSelectedRows) {
      setclearSelectedRows(false);
    }
  }, [ClearSelectedRows]);
  useEffect(() => {
    setAddInventoryItemModal(isAddModalOpen);
  }, [isAddModalOpen]);

  const gridData = useMemo(() => {
    let filteredData = allInventory?.inventory || [];
    setGridState({
      ...gridState,
      totalRecords: allInventory.totalRecords || defaultGridState.totalRecords,
      pageEndRecordNumber:
        allInventory.pageEndRecordNumber ||
        defaultGridState.pageEndRecordNumber,
      pageStartRecordNumber:
        allInventory.pageStartRecordNumber ||
        defaultGridState.pageStartRecordNumber,
    });
    setIsSearchLoading(false);

    return filteredData;
    // eslint-disable-next-line
  }, [allInventory]);
  const clearSearchText = () => {
    handleSearchInputChange("");
  };

  const handleSearchInputChange = (value) => {
    setIsSearchLoading(true);
    setDebouncedSearchText(value);
    handleDebouncedSearch(value);
    scrollRef.current = 0;
    gridRef.current.api.gridBodyCtrl.eBodyViewport.scrollTop = 0;
  };

  const handleDebouncedSearch = useDebouncedCallback((value) => {
    // setSearchText(value);
    updateGridState({ ...gridState, searchQuery: value, pageIndex: 1 });
  }, 1000);

  const onSelectionChanged = (data) => {
    const selectedNodes = data.api.getSelectedRows();
    setSelectedRows(selectedNodes);
  };

  const handleScan = (data) => {
    handleSearchInputChange(data);
  };

  const handleError = () => {};

  const onCellClicked = useCallback((params) => {
    if (
      params.column.colId === "id" ||
      params.column.colId === TABLE_COLUMNS.ACTION_ID ||
      params.data.id === rowBeingEditRef?.current?.id
    ) {
    } else {
      if (rowBeingEditParamRef.current?.data?.id) {
        handleRefreshCells(rowBeingEditParamRef.current);
        redrawTopRows(rowBeingEditParamRef.current);
      }
      rowBeingEditParamRef.current = params;
      rowBeingEditRef.current = {
        ...params.data,
        originalQuantity: params.data.price.quantity,
        originalPrice: params.data.price.unit_sell_price,
      };
      handleRefreshCells(params);

      redrawTopRows(params);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSearchProductType(
      getDefaultFilterType(
        customTypes,
        gridState?.productType || PRODUCT_TYPES_ENUMS.ALL
      )
    );
    // eslint-disable-next-line
  }, [customTypes]);

  useEffect(() => {
    if (currentStore?.id) {
      updateGridState({
        ...gridState,
        filters: prepareFilterForPaginationCall(
          searchProductType,
          searchProductCategory,
          searchProductSubCategory,
          searchInStockFilter
        ),
        productType: searchProductType?.label,
        productCategory: searchProductCategory?.label,
        productSubCategory: searchProductSubCategory?.label,
        inStockFilter: searchInStockFilter,
      });
    }
    // eslint-disable-next-line
  }, [
    currentStore,
    searchProductType,
    searchProductCategory,
    searchProductSubCategory,
    searchInStockFilter,
  ]);

  return (
    <>
      {!isBatchInventoryModal && !addInventoryItemModal && (
        <div>
          <BarcodeReader onError={handleError} onScan={handleScan} />
        </div>
      )}
      <Topbar title="Inventory Details"></Topbar>
      <Row className="m-0">
        <Col
          md={4}
          className="d-flex justify-content-start align-items-center gap-2"
        >
          {!isEmployeeLogin(user) && (
            <>
              <Button
                label={buttonNameConstants.EXPORT_CSV}
                IconImage={ExportCSVIcon}
                className="import-export-button"
                handleClick={() => handleExport()}
              />
              <Button
                label={buttonNameConstants.IMPORT_CSV}
                IconImage={ImportCSVIcon}
                handleClick={() => toggleImportInventoryModal()}
                isDisabled={disableImportInventoryButton}
              />
            </>
          )}
        </Col>
        <Col md={3}></Col>
        <Col
          md={5}
          className="d-flex justify-content-end align-items-center gap-2"
        >
          {!company.isDummyCompany && (
            <Button
              label={buttonNameConstants.SEARCH_COMPANY_INVENTORY}
              IconImage={SearchIcon}
              handleClick={() => {
                toggleIsSearchCompanyInventoryModal();
                scrollRef.current = 0;
                gridRef.current.api.gridBodyCtrl.eBodyViewport.scrollTop = 0;
              }}
              buttonType={buttonTypeConstants.GHOST_BUTTON}
            />
          )}
          <Button
            label={buttonNameConstants.ADD_BATCH}
            IconImage={AddIcon}
            handleClick={() => {
              setIsBatchInventoryModal(!isBatchInventoryModal);
              scrollRef.current = 0;
              gridRef.current.api.gridBodyCtrl.eBodyViewport.scrollTop = 0;
            }}
            buttonType={buttonTypeConstants.LIGHT_PURPLE}
          />
          <Button
            label={buttonNameConstants.ADD_INVENTORY}
            IconImage={AddIcon}
            handleClick={handleAddIventoryItemClick}
          />
        </Col>
        <Col
          md={12}
          className="inventory-overview-card-wrapper d-flex flex-wrap gap-3"
        >
          {!isEmployeeLogin(user) && (
            <>
              {!isSpinnerEnabled(
                spinnerArray,
                inventoryConstants.INVENTORY_HISTORY
              ) ? (
                <>
                  <InventoryOverviewCard
                    label="In Stock Quantity"
                    data={
                      storeInventorySummary
                        ? parseToThousandSeperatorWholeNumber(
                            storeInventorySummary?.quantity
                          )
                        : 0
                    }
                  />

                  <InventoryOverviewCard
                    label="Total Price"
                    data={formatCurrency(
                      storeInventorySummary ? storeInventorySummary?.sale : 0
                    )}
                  />

                  <InventoryOverviewCard
                    label="Total Net"
                    data={formatCurrency(
                      storeInventorySummary?.sale -
                        storeInventorySummary?.purchase || 0
                    )}
                  />
                  <InventoryOverviewCard
                    label="Total Cost"
                    data={formatCurrency(
                      storeInventorySummary
                        ? storeInventorySummary?.purchase
                        : 0
                    )}
                  />
                </>
              ) : (
                <>
                  <SummaryCardSkeleton />
                  <SummaryCardSkeleton />
                  <SummaryCardSkeleton />
                  <SummaryCardSkeleton />
                </>
              )}
            </>
          )}
        </Col>

        <Col md={4}>
          <div>
            <SearchField
              isFocus={true}
              onChange={(e) => handleSearchInputChange(e.target.value)}
              IconImage={SearchIcon}
              label="Search"
              placeHolder="Type or Scan"
              value={debouncedSearchText}
              CrossIcon={debouncedSearchText ? CrossIcon : ""}
              clearSearchText={clearSearchText}
              BlueBoxIcon={BlueBoxIcon}
              LoadingIndicator={
                isSearchLoading ||
                (isButtonDisable(
                  spinnerArray,
                  inventoryConstants.GET_ALL_INVENTORY
                ) &&
                  searchText)
                  ? LoadingIndicator
                  : false
              }
            />
          </div>
        </Col>
        <Col md={8} className="ps-0">
          <div className={`w-100`}>
            <FilterDropdowns
              gridRef={gridRef}
              scrollRef={scrollRef}
              gridState={gridState}
              customTypes={customTypes}
              setGridState={setGridState}
              customCategories={customCategories}
              customSubCategories={customSubCategories}
              setSearchProductType={setSearchProductType}
              setSearchProductCategory={setSearchProductCategory}
              setSearchProductSubCategory={setSearchProductSubCategory}
              defaultProductType={PRODUCT_TYPES_ENUMS.ALL}
              isDisabledAll={isButtonDisable(
                spinnerArray,
                inventoryConstants.GET_ALL_INVENTORY
              )}
              setSearchInStockFilter={setSearchInStockFilter}
              isInStockFilter={true}
            />
          </div>
        </Col>
      </Row>
      {!isBatchInventoryModal &&
        !addInventoryItemModal &&
        !importInventoryModal &&
        !isSearchCompanyInventoryModal && (
          <Row
            className="m-0 w-100 h-100 user-screen-wrapper pt-3"
            onMouseLeave={() => {
              tooltipRef.current?.close();
            }}
          >
            <ServerPaginationTable
              stores={stores}
              colDefs={colDefs}
              gridRef={gridRef}
              suppressRowHoverHighlight={false}
              suppressRowClickSelection={true}
              gridData={
                isSpinnerEnabled(spinnerArray, [
                  inventoryConstants.GET_ALL_INVENTORY,
                  inventoryConstants.UPDATE_INVENTORY,
                ])
                  ? skeletonArray
                  : gridData
              }
              getRowId={getRowId}
              scrollRef={scrollRef}
              gridState={gridState}
              getRowStyle={getRowStyle}
              selectedRows={selectedRows}
              onCellClicked={onCellClicked}
              defaultColDef={defaultColDef}
              updateGridState={updateGridState}
              onSelectionChanged={onSelectionChanged}
              paginationPageSize={gridState.pageSize}
              handleDeleteAllClick={handleDeleteAllClick}
              handleTransferInventory={toggleTransferInventoryModal}
              pageSizeOptions={gridState.pageSizeOptions}
              handlePrintLabelClick={handlePrintLabelClick}
              isDisablePaginationActions={isButtonDisable(
                spinnerArray,
                inventoryConstants.GET_ALL_INVENTORY
              )}
              tableHeight={`calc(100vh - ${
                !isEmployeeLogin(user) && !selectedRows?.length
                  ? "350"
                  : !isEmployeeLogin(user) && selectedRows?.length
                  ? "395"
                  : isEmployeeLogin(user) && !selectedRows?.length
                  ? "290"
                  : "335"
              }px)`}
              isDataLoading={isSpinnerEnabled(spinnerArray, [
                inventoryConstants.GET_ALL_INVENTORY,
                inventoryConstants.UPDATE_INVENTORY,
              ])}
              currentStoreCompany={currentStoreCompany}
              isInlineEditRefresh={isInlineEditRefresh}
              setIsInlineEditRefresh={setIsInlineEditRefresh}
              inlineEditRefreshScrollValue={inlineEditRefreshScrollValue}
              tableId={TABLE_IDS.INVENTORY}
            />
          </Row>
        )}
      {addInventoryItemModal && (
        <AddInventoryItem
          customTypes={customTypes}
          addCustomItem={addCustomItem}
          customCategories={customCategories}
          handleClearFilter={handleClearFilter}
          customSubCategories={customSubCategories}
          addInventoryItemModal={addInventoryItemModal}
          toggleAddInventoryItemModal={toggleAddInventoryItemModal}
        />
      )}
      {isBatchInventoryModal && !isDraftConfirmationModal && (
        <AddBatchInventory
          customTypes={customTypes}
          handleClearFilter={handleClearFilter}
          customCategories={customCategories}
        />
      )}
      <PrintLabelModal
        printLabelModal={printLabelModal}
        togglePrintLabelModal={togglePrintLabelModal}
        selectedRows={selectedRows}
        singlePrintArray={singlePrintArray}
      />
      <ImportInventory
        currentStore={currentStore}
        importInventoryModal={importInventoryModal}
        importCsvFileInventory={importCsvFileInventory}
        toggleImportInventoryModal={toggleImportInventoryModal}
      />
      <ShrinkItemModal
        itemShrinkModal={itemDeleteShrinkModal}
        handleNoButtonClick={handleDeleteNoButtonClick}
        handleYesButtonClick={handleDeleteYesButtonClick}
        toggleItemShrinkModal={toggleItemDeleteShrinkModal}
      />
      <ShrinkItemModal
        itemShrinkModal={itemEditShrinkModal}
        handleNoButtonClick={handleEditNoButtonClick}
        handleYesButtonClick={handleEditYesButtonClick}
        toggleItemShrinkModal={toggleItemEditShrinkModal}
      />
      <ConfirmationModal
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
      />
      {isSearchCompanyInventoryModal && (
        <SearchCompanyInventory
          isSearchCompanyInventoryModal={isSearchCompanyInventoryModal}
          toggleIsSearchCompanyInventoryModal={
            toggleIsSearchCompanyInventoryModal
          }
        />
      )}
      {isTransferInventoryModal && (
        <TransferInventoryModal
          selectedRows={selectedRows}
          singlePrintArray={singlePrintArray}
          isTransferInventoryModal={isTransferInventoryModal}
          toggleTransferInventoryModal={toggleTransferInventoryModal}
        />
      )}
    </>
  );
};
//-------Inventory Items component ends here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  stores: state.store.stores,
  user: state.authentication.user,
  company: state.authentication.company,
  spinnerArray: state.system.spinnerArray,
  currentStore: state.store.currentStore,
  itemOrganization: state.itemOrganization,
  isAddModalOpen: state.inventory.isAddModalOpen,
  currentStoreCompany: state.company.currentStoreCompany,
  defaultZebraPrinter: state.printer.defaultZebraPrinter,
  isBatchInventoryModal: state.inventory.isBatchInventoryModal,
  isDraftConfirmationModal: state.transaction.isDraftConfirmationModal,
  draggableNotification: state.system.draggableNotification,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getPaginatedInventory: (storeId, gridState) =>
    dispatch(inventoryActions.getPaginatedInventory(storeId, gridState)),
  getInventorySummary: (storeId) =>
    dispatch(inventoryActions.getStoreInventorySummary(storeId)),
  deleteInventory: (data, storeId, gridState, isAddShrinkTracking) =>
    dispatch(
      inventoryActions.deleteInventory(
        data,
        storeId,
        gridState,
        isAddShrinkTracking
      )
    ),
  toggleAddModal: (value) => dispatch(inventoryActions.toggleAddModal(value)),
  quantityShrink: (data) => dispatch(inventoryActions.quantityShrink(data)),
  addCustomItem: (data, toastMessage, handleHideModal) =>
    dispatch(
      inventoryActions.addCustomItem(data, toastMessage, handleHideModal)
    ),
  updateInventory: (
    storeId,
    data,
    isLabelNotification,
    gridState,
    isPageRedirect,
    scrollRef,
    isAddShrinkTracking
  ) =>
    dispatch(
      inventoryActions.updateInventory(
        storeId,
        data,
        isLabelNotification,
        gridState,
        isPageRedirect,
        scrollRef,
        isAddShrinkTracking
      )
    ),
  importCsvFileInventory: (data, response) =>
    dispatch(inventoryActions.importCsvFileInventory(data, response)),
  emptyAllInventory: () => dispatch(inventoryActions.emptyAllInventory()),
  updateProductTypes: (storeId, data, handleHideModal) =>
    dispatch(
      inventoryActions.updateProductTypes(storeId, data, handleHideModal)
    ),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  setIsBatchInventoryModal: (isModalOpen) =>
    dispatch({
      type: inventoryConstants.SET_IS_BATCH_INVENTORY + globalConstants.SUCCESS,
      data: isModalOpen,
    }),
  activateImportInventorySpinner: (data) =>
    dispatch(inventoryActions.activateImportInventorySpinner(data)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(Items);
